module.exports = __webpack_public_path__ + "img/车明海.268e1380.jpg";